module.exports = __webpack_public_path__ + "static/media/icn-design.626762d6.svg";